import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { Textarea } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { AccordionModule } from 'primeng/accordion';
import { StepsModule } from 'primeng/steps';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ProgressBarModule } from 'primeng/progressbar';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { PopoverModule } from 'primeng/popover';

import { HisCoreSharedModule } from '../core/his-core-shared.module';
import { HisDialogHeaderComponent } from './component/dialog-header/his-dialog-header.component';
import { HisDocumentationLinkComponent } from './component/helptext/his-documentation-link.component';
import { HisHelptextComponent } from './component/helptext/his-helptext.component';
import { HisHelptextButtonComponent } from './component/helptext/his-helptext-button.component';
import { HisHelptextContentComponent } from './component/helptext/his-helptext-content.component';
import { HisListviewComponent } from './component/listview/his-listview.component';
import { HisListviewEntryComponent } from './component/listview/his-listviewEntry.component';
import { HisRequestComponent } from './component/request/his-request.component';
import { HisTranslationSharedModule } from '../translation/his-translation-shared.module';
import { HisWizardComponent } from './component/wizard/his-wizard.component';
import { HisWizardPageComponent } from './component/wizard/his-wizard-page.component';
import { HisInfoPanelComponent } from './component/helptext/his-info-panel.component';
import { HisDialogHeaderPaginatorComponent } from './component/dialog-header/his-dialog-header-paginator.component';
import { HisHeadingComponent } from './component/his-heading/his-heading.component';


@NgModule( {
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        HisCoreSharedModule,
        HisTranslationSharedModule,

        // PrimeNg
        PanelModule,
        CalendarModule,
        AutoCompleteModule,
        Textarea,
        MultiSelectModule,
        AccordionModule,
        StepsModule,
        PanelMenuModule,
        ProgressBarModule,
        ButtonModule,
        OverlayPanelModule,
        ToastModule,
        DialogModule,
        PopoverModule
    ],
    declarations: [
        HisDialogHeaderComponent,
        HisDialogHeaderPaginatorComponent,
        HisDocumentationLinkComponent,
        HisRequestComponent,
        HisListviewComponent,
        HisListviewEntryComponent,
        HisHelptextComponent,
        HisHelptextButtonComponent,
        HisHelptextContentComponent,
        HisInfoPanelComponent,
        HisWizardComponent,
        HisWizardPageComponent,
        HisHeadingComponent
    ],
    exports: [
        HisDialogHeaderComponent,
        HisDialogHeaderPaginatorComponent,
        HisDocumentationLinkComponent,
        HisRequestComponent,
        HisListviewComponent,
        HisListviewEntryComponent,
        HisHelptextComponent,
        HisHelptextButtonComponent,
        HisHelptextContentComponent,
        HisInfoPanelComponent,
        HisWizardComponent,
        HisWizardPageComponent,
        HisHeadingComponent
    ]
} )
export class HisStructureSharedModule { }
